module.exports = __webpack_public_path__ + "static/media/parque-proprio-250.52f8df6e.jpg";